import { ru } from './ru.ts';

type Dict = typeof ru;
const dict: Dict = ru;   // язык — позже из профиля / Telegram

// t('login.codeSent', { email }) — путь по словарю, {подстановки}
export function t(path: string, vars: Record<string, string | number> = {}): string {
  let v: any = dict;
  for (const k of path.split('.')) v = v?.[k];
  if (typeof v !== 'string') return path;
  return v.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? ''));
}

// ошибка api → текст: из словаря по коду, иначе текст сервера
export function errText(e: unknown): string {
  const code = (e as any)?.code;
  const known = code ? t(`err.${code}`) : '';
  return known && known !== `err.${code}` ? known : (e as any)?.message ?? t('err.server');
}

// «1 нейрон / 3 нейрона / 15 нейронов»
export function neurons(n: number): string {
  const f = n % 10 === 1 && n % 100 !== 11 ? 'one' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'few' : 'many';
  return `${n} ${t(`currency.${f}`)}`;
}
